import { jsx as e } from "react/jsx-runtime";
import * as r from "@radix-ui/react-tabs";
const s = ({ id: t, children: o, testId: a }) => /* @__PURE__ */ e(r.Content, { value: t, "data-testid": a, children: o });
export {
  s as BaseTabContent
};
//# sourceMappingURL=index.es5627.js.map
